import { CloseOutlined } from '@mui/icons-material'
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    Icon,
    Typography,
} from '@mui/material'
import { ReactElement, useEffect, useState } from 'react'
import { fetchSubTemplates } from '../../services/entityInstanceServices'
import { useAppDispatch } from '../../redux/hook'
import { updateLoader } from '../../redux/slices/loaderSlice'
import SelectInput from './SelectInput'
import { useTranslation } from 'react-i18next'
interface SubTemplatesListProps {
    templateId: string
    isOpen: boolean
    onClose: any
    onSubmit: any
    orgId: string
    includeAbstract?: boolean
    submitIfSingle?: boolean
}

const SubTemplatesList = (props: SubTemplatesListProps): ReactElement => {
    const {
        templateId,
        isOpen,
        onClose,
        onSubmit,
        orgId,
        includeAbstract = false,
        submitIfSingle = false,
    } = props
    const { t } = useTranslation()

    const dispatch = useAppDispatch()

    const [isOpenDialog, setIsOpenDialog] = useState<boolean>(false)

    const [temValue, setTemValue] = useState<{
        templateId: string
        templateName: string
    } | null>()
    const [totalTemplates, setTotalTemplates] = useState<any>([])

    useEffect(() => {
        const setSubTemplateDetails = async () => {
            dispatch(updateLoader(true))
            const getSubTemplates: any = await fetchSubTemplates(
                orgId,
                templateId || '',
            )
            let updatedTotalTemplates: any = []
            if (getSubTemplates?.length) {
                updatedTotalTemplates = flattenEntityTemplates(getSubTemplates)
                if (!includeAbstract) {
                    updatedTotalTemplates = updatedTotalTemplates.filter(
                        (i: any) => !i.isAbstract,
                    )
                }
            }

            if (submitIfSingle && updatedTotalTemplates?.length === 1) {
                onSubmit({
                    templateId: updatedTotalTemplates[0]?.templateId,
                    templateName: updatedTotalTemplates[0]?.templateName,
                })
                setIsOpenDialog(false)
            } else {
                setTotalTemplates(updatedTotalTemplates)
                setTemValue({
                    templateId: updatedTotalTemplates[0]?.templateId || '',
                    templateName: updatedTotalTemplates[0]?.templateName || '',
                })
                setIsOpenDialog(true)
            }
            dispatch(updateLoader(false))
        }
        if (isOpen && templateId && orgId) {
            setSubTemplateDetails()
        }
    }, [templateId, isOpen, orgId])

    const flattenEntityTemplates = (entityTemplates: any[]) => {
        const allSubEntityTypes: any[] = []

        const traverse = (entityTemplates: any[]) => {
            for (const entityTemplate of entityTemplates) {
                allSubEntityTypes.push(entityTemplate)
                if (entityTemplate.subTemplates) {
                    traverse(entityTemplate.subTemplates)
                }
            }
        }

        traverse(entityTemplates)
        return allSubEntityTypes
    }

    const onChangeTemplate = (id: string, value: string) => {
        setTemValue({
            templateId: value || '',
            templateName:
                totalTemplates.find((i: any) => i.templateId === value)
                    ?.templateName || '',
        })
    }

    const onSubmitSubTemplate = () => {
        onSubmit(temValue)
        setTemValue(null)
        setTotalTemplates([])
    }

    return (
        <Dialog
            open={isOpenDialog}
            scroll="paper"
            PaperProps={{
                sx: {
                    width: '400px',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
            sx={{ padding: '10px 30px' }}
            onClose={() => onClose()}
        >
            <Box>
                <DialogTitle id="scroll-dialog-title" sx={{ padding: '0px' }}>
                    <Box
                        display="flex"
                        alignItems="center"
                        padding="15px"
                        paddingLeft="20px"
                    >
                        <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                            sx={{ paddingTop: '10px' }}
                        >
                            {t('selectType')}
                        </Typography>
                        <Icon
                            onClick={() => onClose()}
                            sx={{ marginLeft: 'auto' }}
                            fontSize="small"
                            id="sub-templates-close-icon"
                            aria-label={t('close')}
                            title={t('close')}
                        >
                            <CloseOutlined
                                sx={{
                                    color: '#000',
                                    marginTop: '-2px',
                                }}
                            />
                        </Icon>
                    </Box>
                </DialogTitle>
                <DialogContent
                    sx={{
                        height: 'auto',
                    }}
                >
                    <Box
                        sx={{
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <Box sx={{ width: 'calc(100%)' }}>
                            <SelectInput
                                label={t('selectType')}
                                aria-label={t('selectType')}
                                id="subtemplatesList"
                                // value={path[path.length - 1]?.templateId}
                                value={temValue?.templateId || ''}
                                onChange={onChangeTemplate}
                                list={totalTemplates.map((i: any) => {
                                    return {
                                        ...{
                                            id: i.templateId,
                                            name: i.templateName,
                                        },
                                    }
                                })}
                                hasEmpty={false}
                                //    errorMessage={''}
                            />
                        </Box>
                        <Box onClick={() => onSubmitSubTemplate()}>
                            <Button
                                sx={{
                                    mt: 4,
                                }}
                                variant="contained"
                                fullWidth
                                id="sub-templates-submit-button"
                                title={t('add')}
                            >
                                {t('add')}
                            </Button>
                        </Box>
                    </Box>
                </DialogContent>
            </Box>
        </Dialog>
    )
}

export default SubTemplatesList
